import React, { useState, useContext } from 'react';
import { UserContext } from './UserContext';
import { appserverURL,trend_chart_left_gap_days,incrementDate } from './Common';
//--------------------------------------------------------------------------------------------------------
function Chatbot(props) {
  const { token, resourceObj } = useContext(UserContext); // Get the token from context
  const asURL = appserverURL();
  const baseURL = `${asURL}/chatbot/chat`; // Simplified base URL

  const [messages, setMessages] = useState([]); // Chat messages state
  const [userInput, setUserInput] = useState(''); // User input state

  // Function to display messages in the chatbox
  const displayMessage = (role, text) => {
    setMessages((prev) => [...prev, { role, text }]);
  };
  //--------------------------------------------------------------------------------------------------------
  // Function to send a message
  const handleSend = () => {
    if (!userInput.trim()) return; // Ignore empty input

    displayMessage('user', userInput); // Display user message

    // Prepare data for the POST request
    const postData = {
      message: userInput,
      context: 'wave-viewer', // Set context explicitly
      token: token
    };

    console.log('postData:', postData); // Log the data being sent

    fetch(baseURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData), // Send both message and context
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        displayMessage('bot', data.reply); // Display bot's reply
      })
      .catch((err) => {
        displayMessage('bot', `Error occurred: ${err.message}`);
      });

    setUserInput(''); // Clear the input field
  };
  //--------------------------------------------------------------------------------------------------------
  // Handle "Enter" key for sending messages
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSend();
    }
  };


  //--------------------------------------------------------------------------------------------------------
  // loades opportunity to the wave-viewer operated from the chatbot - 
  // tcsd stands for Trend Chart Start Date
  const loadOppWV = (rid, date, tcsd, symbol, days, years) => {
    props.SetOpportunities([])
    props.SetStartDate(date)

    let trend_chart_start_date = incrementDate(date, -trend_chart_left_gap_days); // set to 2 weeks before  - set in common 
    props.SetTrendChartStartDate(trend_chart_start_date)

    props.SetSymbol(symbol)
    props.SetSeasonalYears(years)
    props.SetConsolidatedSeasonalData([])

    props.SetDaysOut(days)
    props.SetMonthsAndQtrs('Months & Qtrs')

    //let rid = props.reportsList[idx]['resourceID']
    let resource_group = resourceObj[parseInt(rid)]

    props.SetReportsDashVisible(false)
    props.SetSelectedSecurity(resource_group)
  }
  //--------------------------------------------------------------------------------------------------------


  // Handle row clicks for Wave Viewer
  const handleRowClick = (event) => {
    const row = event.target.closest('tr'); // Find the closest table row
    if (row && row.dataset.rid) {
      const { rid, date, tcsd, symbol, days, years } = row.dataset; // Extract data-* attributes
      loadOppWV(rid, date, tcsd, symbol, days, years); // Call the Wave Viewer function
    }
  };
  //--------------------------------------------------------------------------------------------------------
  return (
    <div
      id="tradewave-chatbot-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        backgroundColor: 'rgb(245,245,245)',
      }}
    >
      {/* Chatbox Display */}
      <div
        id="chatbox"
        style={{
          flex: 1,
          border: '1px solid #ccc',
          overflowY: 'auto',
          padding: '10px',
          boxSizing: 'border-box',
        }}
        onClick={handleRowClick} // Attach row click handler
      >
        {messages.map((msg, index) => (
          <div key={index}>
            <strong>{msg.role === 'user' ? 'You' : 'TradeWave Bot'}:</strong>
            {/* Render bot's HTML response safely */}
            <div dangerouslySetInnerHTML={{ __html: msg.text }} />
          </div>
        ))}
      </div>

      {/* Input Field and Button */}
      <div
        style={{
          display: 'flex',
          padding: '10px',
          boxSizing: 'border-box',
        }}
      >
        <input
          type="text"
          id="userInput"
          placeholder="Ask TradeWave Chatbot any questions about TradeWave"
          style={{
            flex: 1,
            padding: '5px',
          }}
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)} // Update input state
          onKeyDown={handleKeyDown} // Handle "Enter" key
        />
        <button
          id="sendButton"
          style={{
            width: '80px',
            marginLeft: '10px',
            padding: '5px',
          }}
          onClick={handleSend} // Send message on click
        >
          Send
        </button>
      </div>
    </div>
  );
}

export default Chatbot;
